import styled from 'styled-components';

import { colors, metrics } from 'styles';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 0 2rem;
  margin-top: 1rem;
  margin-bottom: 4rem;

  height: max-content;
  position: relative;

  .filters {
    cursor: pointer;
    display: none;
    align-items: center;
    justify-content: center;
    gap: 0.4rem;
    background-color: var(--primary_color);
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    z-index: 99;
    color: var(--white);
    font-size: 1rem;
    font-weight: 700;
    padding: 0.8rem 0;
  }

  .modal-filters-showcase {
    display: none;
  }

  .grid {
    grid-template-columns: repeat(auto-fill, minmax(13.5rem, 1fr));
  }

  @media (max-width: 1200px) {
    .filters {
      display: flex;
    }

    .modal-filters-showcase {
      display: flex;
    }

    .showcase-content .showcase-aside {
      display: none;
    }

    .modal-container {
      min-width: 0;
      border-radius: 0.8rem;
      padding: 0;
      margin: 0;

      &.withScroll.canClose {
        padding: 1rem;
      }

      .showcase-aside {
        width: 100%;
        margin-right: 0;
      }

      .modal-content.withScroll {
        margin-top: 2.5rem;
      }
    }
  }

  @media (max-width: 768px) {
    .modal-container {
      max-height: 85vh;

      .modal-content {
        max-height: 75vh;
      }
    }
  }

  @media (max-width: 580px) {
    padding: 0;
  }
`;

export const SubHeader = styled.section`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 2rem;
  margin-bottom: 3rem;
  color: var(--primary_color);

  h1 {
    font-size: 2.4rem;
    font-weight: 900;
    color: var(--primary_color);

    &::first-letter {
      text-transform: uppercase;
    }
  }

  .filters-by {
    align-self: flex-start;
    min-width: max-content;
  }

  .filter-classify-by {
    display: flex;
    align-items: center;
    justify-content: end;
    gap: 1rem;
    width: 100%;

    > p {
      font-weight: 700;
    }

    .simple-select {
      height: 2.5rem;
      background-color: white;
      font-size: 0.9rem;
      font-weight: 400;
      color: #a5a5a5;
      width: 15rem;
      z-index: 15;
    }
  }

  @media (max-width: 1200px) {
    flex-direction: column;

    h1 {
      align-self: flex-start;
    }

    .filters-by {
      align-self: flex-end;
    }

    .filter-classify-by {
      flex-direction: column;
      align-items: flex-start;
    }
  }

  @media (max-width: 768px) {
    h1 {
      font-size: 1.8rem;
    }

    .filter-classify-by select {
      font-size: 0.8rem;
      background-size: 0.5rem;
    }
  }

  @media (max-width: 580px) {
    padding: 0 2rem;
  }

  @media (max-width: 520px) {
    h1 {
      font-size: 1.6rem;
    }
  }

  @media (max-width: 400px) {
    h1 {
      font-size: 1.4rem;
    }

    .filter-classify-by {
      align-items: flex-start;
      flex-direction: column;
      gap: 0.4rem;
    }
  }

  @media (max-width: 380px) {
    .filter-classify-by > p {
      font-size: 0.8rem;
    }
  }
`;

export const Content = styled.div`
  display: flex;

  .showcase-list-items {
    width: 100%;
    height: 100%;
  }
`;

export const EmptyList = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  align-self: center;

  width: max-content;
  margin: 3.6rem auto;

  padding: 1.2rem 2.4rem;
  border: 1px solid var(--primary_color);
  border-radius: 0.8rem;
  color: ${colors.text_gray};
`;
